import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-bar-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step = _resolveComponent("Step")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Step, {
      state: _ctx.isActive(1),
      number: 1,
      title: _ctx.$t('dashboard.parametrable.modale.creation.dashboard.stepper.denomination')
    }, null, 8, ["state", "title"]),
    _createVNode(_component_Step, {
      state: _ctx.isActive(2),
      number: 2,
      title: _ctx.$t('dashboard.parametrable.modale.creation.dashboard.stepper.perimetre')
    }, null, 8, ["state", "title"])
  ]))
}